import Cookies from "universal-cookie";

const cookies = new Cookies();

// Same dedicated back-office RestApi used by the supplier explorer.
const BASE = process.env.BACKOFFICE_SERVER_URL || "";

const auditFetch = async (path, { method = "GET", body } = {}) => {
  const { token } = cookies.get("userId") || {};
  try {
    const res = await fetch(`${BASE}${path}`, {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body ? { "Content-Type": "application/json" } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
};

const enc = encodeURIComponent;

export const fetchAuditTargets = () => auditFetch(`/audit/targets`);

export const fetchAudits = (buildingId) => auditFetch(`/audit/list?building_id=${enc(buildingId)}`);

export const fetchAuditReport = (id) => auditFetch(`/audit/report?id=${enc(id)}`);

export const generateAudit = (companyId, buildingId) =>
  auditFetch(`/audit/generate`, { method: "POST", body: { company_id: companyId, building_id: buildingId } });

export const updateAuditFinding = (reportId, findingId, patch) =>
  auditFetch(`/audit/finding?report_id=${enc(reportId)}&finding_id=${enc(findingId)}`, {
    method: "PATCH",
    body: patch,
  });
